import script from "./BatchAddMaterial.vue?vue&type=script&lang=ts&setup=true"
export * from "./BatchAddMaterial.vue?vue&type=script&lang=ts&setup=true"

import "./BatchAddMaterial.vue?vue&type=style&index=0&id=e5568f8c&lang=scss"

const __exports__ = script;

export default __exports__